import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "defective-replacement-vendor",
  value: "Defective_Replacement_To_Vendor",
  labelKey: "inventory.transferDefectiveReplacementToVendor",
  party: "vendor",
  usesDefectiveQty: true,
};

export function DefectiveReplacementToVendorModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
